import { useState, useEffect, useRef } from "react";

import slide1 from "../../assets/slides/slide1.jpeg";
import slide2 from "../../assets/slides/slide2.jpeg";
import slide3 from "../../assets/slides/slide3.jpeg";
import slide4 from "../../assets/slides/slide4.jpeg";
import slide5 from "../../assets/slides/slide5.jpeg";
import slide6 from "../../assets/slides/slide6.jpeg";
import slide7 from "../../assets/slides/slide7.jpeg";
import slide8 from "../../assets/slides/slide8.jpeg";
import slide9 from "../../assets/slides/slide9.jpeg";
import slide10 from "../../assets/slides/slide10.jpeg";

import slide11 from "../../assets/slides/slide11.jpeg";
import slide12 from "../../assets/slides/slide12.jpeg";
import slide13 from "../../assets/slides/slide13.jpeg";
import slide14 from "../../assets/slides/slide14.jpeg";
import slide15 from "../../assets/slides/slide15.jpeg";
import slide16 from "../../assets/slides/slide16.jpeg";
import slide17 from "../../assets/slides/slide17.jpeg";
import slide18 from "../../assets/slides/slide18.jpeg";
import slide19 from "../../assets/slides/slide19.jpeg";
import slide20 from "../../assets/slides/slide20.jpeg";

import slide21 from "../../assets/slides/slide21.jpeg";
import slide22 from "../../assets/slides/slide22.jpeg";
import slide23 from "../../assets/slides/slide23.jpeg";
import slide24 from "../../assets/slides/slide24.jpeg";
import slide25 from "../../assets/slides/slide25.jpeg";
import slide26 from "../../assets/slides/slide26.jpeg";
import slide27 from "../../assets/slides/slide27.jpeg";
import slide28 from "../../assets/slides/slide28.jpeg";
import slide29 from "../../assets/slides/slide29.jpeg";
import slide30 from "../../assets/slides/slide30.jpeg";

/* =========================
   GUIDE IMAGES (JPEG)
========================= */

/* Onboarding */
import onboardingPopup from "../../assets/images/onboardingpopup.jpeg";

/* Dashboard */
import dashboardTop from "../../assets/images/dashboardtop.jpeg";
import dashboardBottom from "../../assets/images/dashboardbottom.jpeg";

/* Profile */
import profilePreview from "../../assets/images/profile.jpeg";

/* Practice */
import practiceConfig from "../../assets/images/practicewholeuipage.jpeg";
import operationSelection from "../../assets/images/operationselectionpage.jpeg";
import typeSelection from "../../assets/images/typeselectionpage.jpeg";

/* Test Page */
import testNormal from "../../assets/images/testnormalpage.jpeg";
import testStreamRunning from "../../assets/images/teststreampage.jpeg";
import testStreamEnded from "../../assets/images/testendingstreampage.jpeg";

/* Analysis */
import analysisNormal from "../../assets/images/analysisnormalpage.jpeg";
import analysisStream from "../../assets/images/analysisstreampage.jpeg";

/* History */
import historyNormal from "../../assets/images/historynormal.jpeg";
import historyStream from "../../assets/images/historystream.jpeg";
import historyFilters from "../../assets/images/historyfilter.jpeg";

/* Performance graph */
import overallPerformanceGraph from "../../assets/images/overallperformancegraph.jpeg";
import accuracyGraph from "../../assets/images/accuracy.jpeg";
import correctIncorrectGraph from "../../assets/images/correct&incorrectanalysis.jpeg";
import timeAnalysisGraph from "../../assets/images/timeanalysis.jpeg";
import streamPerformanceGraph from "../../assets/images/streamperformanceanalysis.jpeg";
import graphHidingCell from "../../assets/images/graphhidingcell.jpeg";

/* Settings */
import settingsPage from "../../assets/images/settings.jpeg";

/* Reset Center */
import resetCustomDate from "../../assets/images/resetcustomdate.jpeg";
import resetCustomTest from "../../assets/images/resetcustomname.jpeg";
import resetHistoryMain from "../../assets/images/resethistorymain.jpeg";
import resetExportHistory from "../../assets/images/exportexcelpage.jpeg";
import resetCombined from "../../assets/images/resetcombine.jpeg";
import resetCenterFull from "../../assets/images/resetcentre.jpeg";

/* =========================
   Guides Page (Docs Style)
========================= */

export default function Guides() {
  const [active, setActive] = useState("overview");
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const checkScreen = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);

      // 🔥 auto-close sidebar on mobile
      if (mobile) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    if (isMobile && sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobile, sidebarOpen]);

  return (
    <div style={s.wrapper}>
      {isMobile && !sidebarOpen && (
        <button
          onClick={() => setSidebarOpen(true)}
          style={{
            position: "fixed",
            top: 76,
            left: 16,
            zIndex: 3000,
            padding: "10px 14px",
            borderRadius: 12,
            border: "none",
            background: "linear-gradient(135deg,#7c3aed,#9333ea)",
            color: "#fff",
            fontWeight: 700,
            cursor: "pointer",
            boxShadow: "0 10px 30px rgba(124,58,237,0.45)",
          }}
        >
          ☰ Guides
        </button>
      )}

      {/* LEFT SIDEBAR */}
      {(!isMobile || sidebarOpen) && (
        <aside
          style={{
            ...s.sidebar,
            ...(isMobile
              ? {
                  position: "fixed",
                  inset: 0,
                  zIndex: 4000,
                  margin: 0,
                  borderRadius: 0,
                  height: "100vh",
                  background: "#ede9fe",
                }
              : {}),
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 24,
            }}
          >
            <h3 style={{ ...s.sideTitle, marginBottom: 0 }}>Guides</h3>
          </div>

          {NAV.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                setActive(item.id);
                if (isMobile) setSidebarOpen(false); // ✅ auto close on mobile
              }}
              style={{
                ...s.sideItem,
                ...(active === item.id ? s.sideItemActive : {}),
              }}
            >
              {item.label}
            </button>
          ))}
        </aside>
      )}
      {!isMobile && <div style={s.divider} />}

      {/* RIGHT CONTENT */}
      <main
        style={{
          ...s.content,
          padding: isMobile ? "80px 18px 40px" : s.content.padding,
        }}
      >
        {active === "overview" && <OverviewGuide />}
        {active === "onboarding" && <Onboarding />}
        {active === "dashboard" && <DashboardGuide />}
        {active === "profile" && <ProfileGuide />}
        {active === "practice" && <PracticeConfigurationGuide />}
        {active === "session-type" && <SessionTypeGuide />}
        {active === "test-page" && <TestPageGuide />}
        {active === "analysis" && <AnalysisPageGuide />}
        {active === "history" && <HistoryGuide />}
        {active === "graphs" && <Graph />}
        {active === "settings" && <SettingsGuide />}
        {active === "reset" && <ResetCenterGuide />}
        {active === "pdf" && <PDFGuide />}
      </main>
    </div>
  );
}

const PDF_SLIDES = [
  slide1,
  slide2,
  slide3,
  slide4,
  slide5,
  slide6,
  slide7,
  slide8,
  slide9,
  slide10,
  slide11,
  slide12,
  slide13,
  slide14,
  slide15,
  slide16,
  slide17,
  slide18,
  slide19,
  slide20,
  slide21,
  slide22,
  slide23,
  slide24,
  slide25,
  slide26,
  slide27,
  slide28,
  slide29,
  slide30,
];

const NAV = [
  { id: "overview", label: "Overview" },
  { id: "onboarding", label: "Onboarding Popup" },
  { id: "dashboard", label: "Dashboard" },
  { id: "profile", label: "Profile" },
  { id: "practice", label: "PracticeConfigurationGuide" },
  { id: "session-type", label: "Session Type: Normal & Stream" },
  { id: "test-page", label: "Test Page" },
  { id: "analysis", label: "Analysis & Performance" },
  { id: "history", label: "History Record" },
  { id: "graphs", label: "Performance Graphs" },
  { id: "settings", label: "Settings" },
  { id: "reset", label: "Reset & Data Handling" },
  { id: "pdf", label: "Full User Guide (PDF)" },
];

function Section({ title, children }) {
  return (
    <section style={s.sectionCard}>
      <h2 style={s.h2}>{title}</h2>
      <div style={s.sectionBody}>{children}</div>
    </section>
  );
}

function Split({ image, reverse = false, children }) {
  return (
    <div
      style={{
        ...s.split,
        flexDirection: reverse ? "row-reverse" : "row",
      }}
    >
      <div style={s.text}>{children}</div>
      {image && <img src={image} alt="guide" style={s.image} />}
    </div>
  );
}

function YouTubeEmbed({ videoId }) {
  return (
    <div
      style={{
        position: "relative",
        paddingBottom: "56.25%", // 16:9
        height: 0,
        marginTop: 24,
        marginBottom: 32,
        borderRadius: 12,
        overflow: "hidden",
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
      }}
    >
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title="SpeedDigits Trainer Overview"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
}
function OverviewGuide() {
  return (
    <Section title="Overview">
      <p>
        <strong>SpeedDigits Trainer</strong> is an arithmetic practice platform
        designed to improve calculation speed, accuracy, and mental focus
        through structured, rule-based training.
      </p>

      <YouTubeEmbed videoId="dQw4w9WgXcQ" />

      <p style={{ fontSize: 14, opacity: 0.75, marginTop: -12 }}>
        ▶ Watch a short walkthrough explaining how SpeedDigits Trainer works.
      </p>

      {/* ===== PRACTICE SYSTEM ===== */}
      <h3 style={s.h3}>SpeedDigits Trainer, the Practice System</h3>
      <p>
        SpeedDigits Trainer is not a simple calculator or quiz tool. It is a
        controlled practice environment where practice sessions are structured,
        behavior changes based on selected modes, and feedback is immediate and
        performance-driven.
      </p>

      <p>
        The goal is not just to get answers, but to train the thinking process
        behind them.
      </p>

      {/* ===== WHAT MAKES IT DIFFERENT ===== */}
      <h3 style={s.h3}>What Makes SpeedDigits Trainer Different</h3>
      <ul>
        <li>Clear separation between accuracy training and speed training</li>
        <li>Stream Mode intentionally limited for mental consistency</li>
        <li>Configuration rules that prevent misleading practice</li>
        <li>Analysis derived from actual performance, not estimates</li>
        <li>Local-only data storage with full user control</li>
      </ul>

      <p>
        Instead of deciding what is “easy” or “hard” for the user, SpeedDigits
        Trainer provides clear rules and lets improvement emerge through
        practice.
      </p>

      {/* ===== PRACTICE MODES ===== */}
      <h3 style={s.h3}>Practice Modes</h3>

      <h4 style={s.h4}>Normal Mode</h4>
      <ul>
        <li>Step-by-step accuracy-focused practice</li>
        <li>Concept clarity and structured problem solving</li>
        <li>Each question is answered individually</li>
      </ul>

      <h4 style={s.h4}>Stream Mode</h4>
      <ul>
        <li>Continuous number flow with one final answer</li>
        <li>Focus on speed, mental endurance, and concentration</li>
        <li>Designed for advanced and competitive training</li>
      </ul>

      {/* ===== ANALYSIS ===== */}
      <h3 style={s.h3}>Analysis & Progress Tracking</h3>
      <ul>
        <li>Accuracy and correctness metrics after every session</li>
        <li>Average, fastest, and slowest response times</li>
        <li>Question-wise analysis for Normal Mode</li>
        <li>Stream-wise evaluation for Stream Mode</li>
      </ul>

      {/* ===== PRIVACY ===== */}
      <h3 style={s.h3}>Privacy & Data Control</h3>
      <ul>
        <li>No sign-up or login required</li>
        <li>No cloud storage or data sharing</li>
        <li>All data stored locally on the user’s device</li>
        <li>Full control over history, exports, and resets</li>
      </ul>

      {/* ===== WAY OF LEARNING ===== */}
      <h3 style={s.h3}>SpeedDigits Trainer — A Way of Learning</h3>
      <p>
        SpeedDigits Trainer is built on the idea that skill improves through
        disciplined practice, not shortcuts.
      </p>

      <ul>
        <li>Structured repetition builds accuracy</li>
        <li>Honest feedback reveals mistakes</li>
        <li>Speed is increased only after fluency</li>
        <li>Focus and consistency are trained deliberately</li>
      </ul>

      <p>
        By separating accuracy-focused practice from speed-focused practice, the
        platform reflects how real learning happens: understanding first,
        fluency second, speed last.
      </p>

      {/* ===== SCIENTIFIC THOUGHT ===== */}
      <blockquote style={{ marginTop: 32, fontStyle: "italic" }}>
        “It is not knowledge, but the act of learning, not possession but the
        act of getting there, which grants the greatest enjoyment.”
        <br />
        <strong>— Carl Friedrich Gauss</strong>
      </blockquote>

      <p style={{ marginTop: 16 }}>
        SpeedDigits Trainer is designed around this idea — that progress comes
        not from knowing answers, but from training the mind through deliberate,
        disciplined practice.
      </p>
    </Section>
  );
}
function Onboarding() {
  return (
    <Section title="Onboarding Popup">
      {/* ===== MAIN LAYOUT ===== */}
      <div style={{ ...s.split, alignItems: "flex-start" }}>
        {/* LEFT: IMAGE */}
        <img src={onboardingPopup} alt="Onboarding Popup" style={s.image} />

        {/* RIGHT: CONTENT */}
        <div style={s.text}>
          {/* INTRO */}
          <h3 style={s.h3}>Introduction</h3>
          <p>
            The onboarding popup appears when you use
            <strong> SpeedDigits Trainer </strong>
            for the first time.
          </p>
          <p>
            It helps personalize the experience before starting practice and
            ensures that the training flow matches the user’s level.
          </p>

          {/* REQUIRED & OPTIONAL */}
          <h3 style={s.h3}>Required & Optional Fields</h3>

          <h4 style={s.h4}>Required inputs (needed to start practice)</h4>
          <ul>
            <li>
              <strong>Name</strong> – used for personalization
            </li>
            <li>
              <strong>Class</strong> – helps adjust difficulty and learning flow
            </li>
            <li>
              <strong>Gender</strong> – used for basic profile setup
            </li>
          </ul>

          <h4 style={s.h4}>Optional inputs (can be skipped)</h4>
          <ul>
            <li>Profile Photo – visual personalization</li>
            <li>Date of Birth – age-based customization</li>
            <li>Email – optional, not used for login</li>
          </ul>

          {/* NO LOGIN */}
          <h3 style={s.h3}>No Sign-Up or Login</h3>
          <ul>
            <li>This is not a sign-up or login form</li>
            <li>No account is created</li>
            <li>All data is stored locally on your device only</li>
          </ul>

          {/* RESET */}
          <h3 style={s.h3}>Reset & Fresh Start</h3>
          <ul>
            <li>Clearing data removes all saved information</li>
            <li>The app returns to its initial state</li>
            <li>The onboarding popup appears again</li>
          </ul>

          {/* WHY USED */}
          <h3 style={s.h3}>Why this information is used</h3>
          <ul>
            <li>To personalize the interface</li>
            <li>To improve practice and analysis experience</li>
            <li>Not shared, not uploaded, and fully under user control</li>
          </ul>
        </div>
      </div>
    </Section>
  );
}
function DashboardGuide() {
  return (
    <Section title="Dashboard">
      {/* ===== OVERVIEW (TOP IMAGE ON RIGHT) ===== */}
      <Split image={dashboardTop}>
        <div>
          <p>
            The Dashboard is the main control center of
            <strong> SpeedDigits Trainer</strong>.
          </p>

          <p>
            It provides quick access to practice sessions, performance analysis,
            learning resources, and app controls.
          </p>

          <h3 style={s.h3}>Personal</h3>

          <h4 style={s.h4}>Profile</h4>
          <ul>
            <li>Stores basic user details for personalization</li>
            <li>Helps tailor the learning experience</li>
            <li>Can be updated anytime</li>
          </ul>

          <h4 style={s.h4}>Test History</h4>
          <ul>
            <li>Keeps a record of past practice sessions</li>
            <li>Allows users to review previous attempts</li>
            <li>Helps track consistency over time</li>
          </ul>

          <h4 style={s.h4}>Performance Analysis</h4>
          <ul>
            <li>Shows overall performance after tests</li>
            <li>Displays accuracy, speed, and timing insights</li>
            <li>Helps identify strengths and weak areas</li>
          </ul>

          <h3 style={s.h3}>Learning</h3>

          <h4 style={s.h4}>Guides & Tutorials</h4>
          <ul>
            <li>Explains how different parts of the app work</li>
            <li>Helps new users get started quickly</li>
            <li>Acts as a reference for features and modes</li>
          </ul>
        </div>
      </Split>

      {/* ===== APP SECTION (BOTTOM IMAGE ON LEFT) ===== */}
      <Split image={dashboardBottom} reverse>
        <div>
          <h3 style={s.h3}>App</h3>

          <h4 style={s.h4}>Settings</h4>
          <ul>
            <li>Customize app behavior and appearance</li>
            <li>Control practice and UI preferences</li>
          </ul>

          <h4 style={s.h4}>Reset Data</h4>
          <ul>
            <li>Clears all locally stored information</li>
            <li>Returns the app to its initial state</li>
            <li>Useful for switching users or starting fresh</li>
          </ul>

          <h3 style={s.h3}>Account</h3>

          <h4 style={s.h4}>Sign In / Login</h4>
          <ul>
            <li>Reserved for future account-based features</li>
          </ul>

          <h3 style={s.h3}>Company</h3>
          <ul>
            <li>Privacy Policy – explains data handling</li>
            <li>Terms of Service – usage rules</li>
            <li>Refund Policy – if applicable</li>
            <li>Contact – official communication</li>
          </ul>

          <h3 style={s.h3}>Support</h3>

          <h4 style={s.h4}>Help & Feedback</h4>
          <ul>
            <li>Share feedback or report issues</li>
            <li>Helps improve the app experience</li>
          </ul>
        </div>
      </Split>
    </Section>
  );
}

function ProfileGuide() {
  return (
    <Section title="Profile">
      {/* ================= TOP DESCRIPTION ================= */}
      <p>
        The Profile section is used to personalize the
        <strong> SpeedDigits Trainer </strong>
        experience. All details can be edited anytime.
      </p>

      {/* ================= TWO COLUMN CONTENT ================= */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 32,
          marginTop: 24,
        }}
      >
        {/* ===== LEFT COLUMN ===== */}
        <div>
          <h3 style={s.h3}>Profile Details</h3>

          <h4 style={s.h4}>Profile Photo</h4>
          <p>Optional visual identity.</p>

          <h4 style={s.h4}>Name</h4>
          <p>Used for display and personalization.</p>

          <h4 style={s.h4}>Class</h4>
          <p>Helps adjust learning expectations.</p>

          <h4 style={s.h4}>Date of Birth</h4>
          <p>Used to calculate age.</p>
        </div>

        {/* ===== RIGHT COLUMN ===== */}
        <div>
          <h3 style={{ visibility: "hidden" }}>Spacer</h3>

          <h4 style={s.h4}>Age</h4>
          <p>Calculated automatically from Date of Birth.</p>

          <h4 style={s.h4}>Gender</h4>
          <p>Optional personal detail.</p>

          <h4 style={s.h4}>Email</h4>
          <p>Optional contact detail.</p>

          <h4 style={s.h4}>Description</h4>
          <p>Write about yourself, interests, or goals.</p>
        </div>
      </div>

      {/* ================= IMPORTANT NOTES ================= */}
      <h3 style={s.h3}>Important Notes</h3>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 32,
          marginTop: 16,
        }}
      >
        <ul>
          <li>
            <strong>Class range:</strong> 0 – 14
            <ul>
              <li>0 → UKG / LKG</li>
              <li>1 – 12 → School classes</li>
              <li>13 → Dropper</li>
              <li>14 → College</li>
            </ul>
          </li>
        </ul>

        <ul>
          <li>Age is auto-calculated from Date of Birth.</li>
          <li>Email must be in a valid format.</li>
          <li>Date of Birth must be earlier than today.</li>
        </ul>
      </div>

      {/* ================= IMAGE AT BOTTOM (FULL WIDTH) ================= */}
      <div
        style={{
          marginTop: 48,
          width: "100%",
        }}
      >
        <img
          src={profilePreview}
          alt="Profile Preview"
          style={{
            width: "100%",
            height: "auto",
            aspectRatio: "1865 / 545",
            borderRadius: 16,
            objectFit: "cover",
          }}
        />
      </div>
    </Section>
  );
}
function PracticeConfigurationGuide() {
  return (
    <Section title="Practice Configuration">
      <div
        style={{
          display: "flex",
          gap: 40,
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* LEFT : CONTENT */}
        <div style={{ flex: 1 }}>
          <p>
            This section lets you set up how your practice session will run. All
            options can be adjusted before starting the test.
          </p>

          <h3 style={s.h3}>Configuration Fields</h3>

          <h4 style={s.h4}>Test Name</h4>
          <ul>
            <li>Identifies your practice session</li>
            <li>Used for history and tracking (optional)</li>
          </ul>

          <h4 style={s.h4}>Operation</h4>
          <ul>
            <li>Selects the type of calculation</li>
            <li>Example: Addition, Multiplication</li>
          </ul>

          <h4 style={s.h4}>Difficulty</h4>
          <ul>
            <li>Controls overall question complexity</li>
            <li>Works together with digits and range</li>
          </ul>

          <h4 style={s.h4}>Range (From – To)</h4>
          <ul>
            <li>Sets the minimum and maximum values</li>
            <li>Useful for focused range-based practice</li>
          </ul>

          <h4 style={s.h4}>Digits for First Number</h4>
          <ul>
            <li>Number of digits for the first value</li>
          </ul>

          <h4 style={s.h4}>Digits for Second Number</h4>
          <ul>
            <li>Number of digits for the second value</li>
          </ul>

          <h4 style={s.h4}>Number of Questions</h4>
          <ul>
            <li>Total questions in the session</li>
            <li>Leave empty for unlimited practice</li>
          </ul>

          <h4 style={s.h4}>Start Practice</h4>
          <ul>
            <li>Begins the session using selected settings</li>
          </ul>

          <h3 style={s.h3}>Important Notes</h3>

          <h4 style={s.h4}>Range vs Digits</h4>
          <ul>
            <li>
              When Range is used, digit selection is automatically disabled
            </li>
            <li>Range already controls number size</li>
          </ul>

          <h4 style={s.h4}>Test Name Tip</h4>
          <ul>
            <li>Default test names are recommended for better organization</li>
            <li>Custom names are optional</li>
          </ul>
        </div>

        {/* RIGHT : IMAGE */}
        <div
          style={{
            flex: 1.2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={practiceConfig}
            alt="Practice Configuration"
            style={{
              width: "100%",
              maxWidth: 640,
              transform: "scale(1.25)",
              borderRadius: 16,
            }}
          />
        </div>
      </div>
    </Section>
  );
}
function SessionTypeGuide() {
  const row = {
    display: "flex",
    gap: 24,
    alignItems: "center",
    marginTop: 32,
  };

  const col = { flex: 1 };
  const img = { width: "100%", borderRadius: 12 };

  return (
    <Section title="Session Type: Normal & Stream">
      <p>The Type option decides how questions appear during practice.</p>

      {/* ===== NORMAL + STREAM ===== */}
      <div style={row}>
        <div style={col}>
          <h3 style={s.h3}>Normal Mode</h3>
          <ul>
            <li>Questions appear one by one</li>
            <li>Each question needs an individual answer</li>
            <li>Follows the Number of Questions setting</li>
            <li>Best for accuracy and structured practice</li>
          </ul>

          <h3 style={s.h3}>Stream Mode</h3>
          <ul>
            <li>Numbers appear in a continuous flow</li>
            <li>You calculate mentally and enter one final answer</li>
            <li>Focused on speed and concentration</li>
          </ul>
        </div>

        <div style={col}>
          <img src={operationSelection} alt="Operation Selection" style={img} />
        </div>
      </div>

      {/* ===== STREAM AVAILABILITY ===== */}
      <div style={row}>
        <div style={col}>
          <img src={typeSelection} alt="Session Type Selection" style={img} />
        </div>

        <div style={col}>
          <h3 style={s.h3}>Stream Mode Availability</h3>
          <ul>
            <li>Addition</li>
            <li>Multiplication</li>
          </ul>

          <h3 style={s.h3}>Important Notes</h3>
          <ol>
            <li>
              <strong>Digit Selection (Stream Mode)</strong>
              <ul>
                <li>User selects only the first digit</li>
                <li>Second digit is chosen automatically</li>
                <li>Digit selection makes the stream unpredictable</li>
              </ul>
            </li>

            <li style={{ marginTop: 12 }}>
              <strong>Range in Stream Mode</strong>
              <ul>
                <li>Numbers are generated only within the selected range</li>
              </ul>
            </li>

            <li style={{ marginTop: 12 }}>
              <strong>Range vs Digits (Both Modes)</strong>
              <ul>
                <li>Selecting Range disables digit selection</li>
                <li>Applies to both Normal and Stream modes</li>
              </ul>
            </li>
          </ol>
        </div>
      </div>

      {/* ===== PRACTICE UI ===== */}
      <div style={{ marginTop: 48 }}>
        <h3 style={s.h3}>Practice Interface</h3>
        <img
          src={practiceConfig}
          alt="Practice Configuration UI"
          style={{
            width: "100%",
            marginTop: 16,
            borderRadius: 14,
          }}
        />
      </div>
    </Section>
  );
}
function TestPageGuide() {
  const row = {
    display: "flex",
    gap: 32,
    alignItems: "flex-start",
    marginTop: 40,
  };

  const col = { flex: 1 };

  const img = {
    width: "85%",
    maxWidth: 360,
    borderRadius: 12,
  };

  return (
    <Section title="Test Page">
      <p>
        The Test Page is where actual practice happens. Depending on the
        selected calculation mode, the test experience behaves differently.
      </p>

      {/* ===== NORMAL TEST PAGE ===== */}
      <div style={row}>
        <div style={col}>
          <h3 style={s.h3}>Normal Test Page</h3>
          <p>Normal Mode is designed for step-by-step accuracy practice.</p>

          <h4 style={s.h4}>How it works</h4>
          <ul>
            <li>One question is shown at a time</li>
            <li>User enters an answer and submits</li>
            <li>
              Instant feedback:
              <ul>
                <li>✅ Green blink → correct</li>
                <li>❌ Red blink → wrong</li>
              </ul>
            </li>
            <li>Next question appears automatically</li>
          </ul>

          <h4 style={s.h4}>Controls & Flexibility</h4>
          <ul>
            <li>End / Abort button available anytime</li>
            <li>Abort can be enabled or disabled from Settings</li>
            <li>
              Optional keypad:
              <ul>
                <li>Physical keyboard disabled</li>
                <li>Input only via on-screen keypad</li>
                <li>Submit button confirms answer</li>
              </ul>
            </li>
          </ul>

          <h4 style={s.h4}>Best for</h4>
          <ul>
            <li>Learning concepts</li>
            <li>Accuracy improvement</li>
            <li>Beginners</li>
          </ul>
        </div>

        <div style={col}>
          <img src={testNormal} alt="Normal Test Page" style={img} />
        </div>
      </div>

      {/* ===== STREAM TEST PAGE ===== */}
      <div style={row}>
        <div style={col}>
          <img src={testStreamRunning} alt="Stream Test Running" style={img} />
        </div>

        <div style={col}>
          <h3 style={s.h3}>Stream Test Page</h3>
          <p>
            Stream Mode focuses on continuous mental calculation and sustained
            attention.
          </p>

          <h4 style={s.h4}>How it works</h4>
          <ul>
            <li>Numbers appear continuously</li>
            <li>No submission during the stream</li>
            <li>User processes the full sequence mentally</li>
            <li>Numbers change automatically</li>
          </ul>

          <h4 style={s.h4}>Button behavior</h4>
          <ul>
            <li>Abort button is disabled during the stream</li>
            <li>Answer input is locked</li>
          </ul>

          <h4 style={s.h4}>Best for</h4>
          <ul>
            <li>Speed training</li>
            <li>Mental endurance</li>
            <li>Advanced users</li>
          </ul>
        </div>
      </div>

      {/* ===== STREAM ENDED ===== */}
      <div style={row}>
        <div style={col}>
          <h3 style={s.h3}>Stream End & Final Answer</h3>
          <ul>
            <li>Stream stops automatically after final number</li>
            <li>
              Message shown:
              <br />
              <strong>“STREAM ENDED – Enter final answer”</strong>
            </li>
            <li>User enters the final combined answer</li>
            <li>Submit button becomes active</li>
            <li>Abort / End button is enabled</li>
          </ul>
        </div>

        <div style={col}>
          <img src={testStreamEnded} alt="Stream Ended Screen" style={img} />
        </div>
      </div>
    </Section>
  );
}
function AnalysisPageGuide() {
  const row = {
    display: "flex",
    gap: 32,
    alignItems: "flex-start",
    marginTop: 32,
  };

  const col = { flex: 1 };

  const img = {
    width: "100%",
    maxWidth: 900,
    borderRadius: 14,
  };

  return (
    <Section title="Analysis Page">
      <p>
        The Analysis Page summarizes your test performance and helps you review
        accuracy, speed, and mistakes.
      </p>

      {/* ===== TEST INFORMATION ===== */}
      <h3 style={s.h3}>Test Information</h3>
      <ul>
        <li>Test name</li>
        <li>Operation and mode (Normal / Stream)</li>
        <li>Difficulty level</li>
        <li>Date and time of the test</li>
      </ul>
      <p>
        Use <strong>← New Test</strong> to return and start a fresh test.
      </p>

      {/* ===== PERFORMANCE SUMMARY ===== */}
      <h3 style={s.h3}>Performance Summary</h3>
      <ul>
        <li>
          <strong>Accuracy</strong> – Percentage of correct answers
        </li>
        <li>
          <strong>Correct</strong> – Correct answers out of total
        </li>
        <li>
          <strong>Avg Time</strong> – Average time per question
        </li>
        <li>
          <strong>Fastest</strong> – Quickest response time
        </li>
        <li>
          <strong>Slowest</strong> – Slowest response time
        </li>
      </ul>

      {/* ===== NORMAL TEST ANALYSIS ===== */}
      <div style={row}>
        <div style={col}>
          <h3 style={s.h3}>Normal Test Analysis</h3>
          <ul>
            <li>Each question is evaluated separately</li>
            <li>
              The table shows:
              <ul>
                <li>Question</li>
                <li>Your answer</li>
                <li>Correct answer</li>
                <li>Time taken</li>
                <li>Result (✔ / ✖)</li>
              </ul>
            </li>
            <li>Green indicates correct answers</li>
            <li>Red indicates incorrect answers</li>
          </ul>
        </div>

        <div style={col}>
          <img src={analysisNormal} alt="Normal Test Analysis" style={img} />
        </div>
      </div>

      {/* ===== STREAM TEST ANALYSIS ===== */}
      <div style={row}>
        <div style={col}>
          <img src={analysisStream} alt="Stream Test Analysis" style={img} />
        </div>

        <div style={col}>
          <h3 style={s.h3}>Stream Test Analysis</h3>
          <ul>
            <li>The entire stream is treated as one problem</li>
            <li>Only the final answer is evaluated</li>
            <li>Time shown is the total stream duration</li>
            <li>
              The table displays:
              <ul>
                <li>Stream</li>
                <li>Your final answer</li>
                <li>Correct answer</li>
                <li>Total time</li>
                <li>Result</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      {/* ===== QUESTION BREAKDOWN ===== */}
      <h3 style={s.h3}>Question Breakdown</h3>
      <ul>
        <li>A detailed table for reviewing performance</li>
        <li>Helps identify mistakes and speed patterns</li>
      </ul>

      <p style={{ marginTop: 24 }}>
        This page helps you clearly understand performance and track improvement
        over time.
      </p>
    </Section>
  );
}

function HistoryGuide() {
  const row = {
    display: "flex",
    gap: 32,
    alignItems: "flex-start",
    marginTop: 32,
  };

  const col = { flex: 1 };

  const imgNormal = {
    width: "100%",
    maxWidth: 900,
    minHeight: 300,
    borderRadius: 14,
  };

  const imgStream = {
    width: "100%",
    maxWidth: 900,
    minHeight: 300,
    borderRadius: 14,
  };

  const imgFilters = {
    width: "100%",
    maxWidth: 800,
    minHeight: 300,
    borderRadius: 12,
  };

  return (
    <Section title="History Record">
      <p>
        The <strong>History Record</strong> page maintains a structured log of
        all practice sessions completed in SpeedDigits Trainer.
      </p>

      {/* ===== NORMAL TEST HISTORY ===== */}
      <div style={row}>
        <div style={col}>
          <h3 style={s.h3}>Normal Test History</h3>
          <p>
            Normal Test History records step-by-step accuracy-based practice
            sessions.
          </p>

          <ul>
            <li>Test name</li>
            <li>Date and time of attempt</li>
            <li>Operation</li>
            <li>Difficulty</li>
            <li>Accuracy percentage</li>
            <li>Correct answers</li>
            <li>Total questions attempted</li>
            <li>Average time per question</li>
            <li>Fastest and slowest response time</li>
            <li>Total time spent</li>
          </ul>
        </div>

        <div style={col}>
          <img
            src={historyNormal}
            alt="Normal Test History"
            style={imgNormal}
          />
        </div>
      </div>

      {/* ===== STREAM TEST HISTORY ===== */}
      <div style={row}>
        <div style={col}>
          <img
            src={historyStream}
            alt="Stream Test History"
            style={imgStream}
          />
        </div>

        <div style={col}>
          <h3 style={s.h3}>Stream Test History</h3>
          <p>
            Stream Test History records continuous calculation sessions where
            the entire stream is treated as a single problem.
          </p>

          <ul>
            <li>Test name</li>
            <li>Date and time</li>
            <li>Operation type</li>
            <li>Difficulty level</li>
            <li>Total stream duration</li>
            <li>Final result (Correct / Wrong)</li>
          </ul>

          <p>Question-wise breakdown is not shown for Stream Mode.</p>
        </div>
      </div>

      {/* ===== FILTERS ===== */}
      <div style={row}>
        <div style={col}>
          <h3 style={s.h3}>Filters & Controls</h3>
          <ul>
            <li>Filter by operation</li>
            <li>Filter by time range</li>
            <li>Custom date range selection</li>
            <li>Reset filters to view all records</li>
          </ul>

          <p>Filters apply instantly and never delete history data.</p>
        </div>

        <div style={col}>
          <img src={historyFilters} alt="History Filters" style={imgFilters} />
        </div>
      </div>

      {/* ===== UNLIMITED QUESTIONS HANDLING ===== */}
      <div style={{ marginTop: 40 }}>
        <h3 style={s.h3}>Unlimited Questions Handling</h3>
        <p>
          When the Number of Questions is set to <strong>0</strong>, the test
          runs in unlimited mode.
        </p>

        <ul>
          <li>Total Questions is calculated from actual attempts</li>
          <li>History records the number of questions answered</li>
          <li>Total Questions is never stored as zero</li>
        </ul>
      </div>

      {/* ===== RELATION WITH ANALYSIS ===== */}
      <div style={{ marginTop: 40 }}>
        <h3 style={s.h3}>Relation with Analysis & Graphs</h3>
        <ul>
          <li>Analysis is generated directly from History</li>
          <li>Deleting history updates analysis instantly</li>
          <li>No duplicate data storage exists</li>
        </ul>
      </div>

      {/* ===== DATA SAFETY ===== */}
      <div style={{ marginTop: 40 }}>
        <h3 style={s.h3}>Data Safety & Control</h3>
        <ul>
          <li>No cloud sync or external servers</li>
          <li>No login required</li>
          <li>History can be reset anytime</li>
        </ul>
      </div>
    </Section>
  );
}
function Graph() {
  return (
    <Section title="Performance Graph">
      <p>
        The Analysis & Performance page converts your test history into clear
        visual insights. It helps you understand accuracy, speed, consistency,
        and overall performance trends using interactive charts.
      </p>

      {/* ===== HOW ANALYSIS WORKS ===== */}
      <Split>
        <div>
          <h3 style={s.h3}>How Analysis Works</h3>
          <ul>
            <li>Analysis is generated automatically from Test History</li>
            <li>No separate save exists for analysis</li>
            <li>Clearing history updates analysis instantly</li>
            <li>
              Normal and Stream tests are analyzed separately using
              mode-specific logic
            </li>
          </ul>
        </div>
      </Split>

      {/* ===== NORMAL MODE ===== */}
      <Split reverse>
        <div>
          <h3 style={s.h3}>Normal Mode – Performance Charts</h3>
          <p>
            Normal Mode focuses on accuracy and speed per question. Four charts
            are shown to reflect detailed performance trends.
          </p>
        </div>
      </Split>

      {/* ===== ACCURACY ===== */}
      <Split image={accuracyGraph}>
        <div>
          <h4 style={s.h4}>Accuracy Chart</h4>
          <ul>
            <li>Shows accuracy percentage (%) per Normal test</li>
            <li>X-axis → Test sequence</li>
            <li>Y-axis → Accuracy %</li>
          </ul>

          <p>
            <strong>Why it matters:</strong> Tracks consistency and improvement
            over time.
          </p>
        </div>
      </Split>

      {/* ===== CORRECT VS INCORRECT ===== */}
      <Split image={correctIncorrectGraph} reverse>
        <div>
          <h4 style={s.h4}>Correct vs Incorrect Chart</h4>
          <ul>
            <li>Two lines: Correct % and Incorrect %</li>
            <li>Correct % = (Correct ÷ Total Questions) × 100</li>
            <li>Incorrect % = 100 − Correct %</li>
          </ul>

          <p>
            <strong>Why it matters:</strong> Clearly reveals mistake patterns.
          </p>
        </div>
      </Split>

      {/* ===== TIME ANALYSIS ===== */}
      <Split image={timeAnalysisGraph}>
        <div>
          <h4 style={s.h4}>Time Analysis Chart</h4>
          <ul>
            <li>Average Time per question</li>
            <li>Fastest response time</li>
            <li>Slowest response time</li>
          </ul>

          <p>
            <strong>Formulas used:</strong>
          </p>
          <ul>
            <li>Avg Time = Total time ÷ Number of questions</li>
            <li>Fastest = Minimum response time</li>
            <li>Slowest = Maximum response time</li>
          </ul>
        </div>
      </Split>

      {/* ===== PERFORMANCE RATING ===== */}
      <Split image={overallPerformanceGraph} reverse>
        <div>
          <h4 style={s.h4}>Overall Performance Chart</h4>
          <p>
            This chart represents rating-based performance, not raw accuracy.
          </p>

          <p>
            <strong>Expected Time per Question (c) = 2 seconds</strong>
          </p>

          <ul>
            <li>Accuracy ≥ 98 & avgTime &lt; 1×c → Outstanding (100)</li>
            <li>Accuracy ≥ 95 & avgTime &lt; 2×c → Excellent (90)</li>
            <li>Accuracy ≥ 90 & avgTime &lt; 3×c → Very Good+ (80)</li>
            <li>Accuracy ≥ 85 & avgTime &lt; 4×c → Very Good (70)</li>
            <li>Accuracy ≥ 80 & avgTime &lt; 5×c → Good (60)</li>
            <li>Accuracy ≥ 65 & avgTime &lt; 6×c → Average (50)</li>
            <li>Accuracy ≥ 50 & avgTime &lt; 8×c → Poor (40)</li>
            <li>Else → Needs Improvement (30)</li>
          </ul>

          <p>
            The most recent test determines the <strong>Latest Rating</strong>.
          </p>
        </div>
      </Split>

      {/* ===== STREAM MODE ===== */}
      <Split image={streamPerformanceGraph}>
        <div>
          <h3 style={s.h3}>Stream Mode – Special Analysis</h3>
          <ul>
            <li>Each stream test is treated as one combined problem</li>
            <li>Y-axis → Total stream time (minutes)</li>
            <li>
              Dot color:
              <ul>
                <li>Green → Correct</li>
                <li>Red → Wrong</li>
              </ul>
            </li>
          </ul>

          <p>
            Stream analysis focuses on mental endurance and focus rather than
            per-question accuracy.
          </p>
        </div>
      </Split>

      {/* ===== INTERACTIVITY ===== */}
      <Split image={graphHidingCell} reverse>
        <div>
          <h3 style={s.h3}>Interactive Chart Controls</h3>
          <ul>
            <li>Each legend color box is clickable</li>
            <li>Click to hide or show individual data lines</li>
            <li>Useful for focusing on one metric at a time</li>
          </ul>
        </div>
      </Split>

      {/* ===== TRANSPARENCY ===== */}
      <div style={{ marginTop: 40 }}>
        <h3 style={s.h3}>Transparency & Future Improvements</h3>
        <ul>
          <li>All analysis formulas are fully transparent</li>
          <li>Rating logic balances speed and accuracy</li>
          <li>
            Users may suggest exam-oriented or olympiad-style formulas via
            Feedback
          </li>
          <li>
            Validated international formulas may be added in future updates
          </li>
        </ul>
      </div>
    </Section>
  );
}
function SettingsGuide() {
  const row = {
    display: "flex",
    gap: 40,
    alignItems: "flex-start",
    marginTop: 32,
  };

  const col = { flex: 1 };

  const imgSettings = {
    width: "100%",
    maxWidth: "100%",
    minHeight: 620,
    marginTop: 48,
    borderRadius: 20,
    objectFit: "contain",
  };

  return (
    <Section title="Settings">
      <p>
        The Settings page allows users to customize how the app looks and how
        practice sessions behave. All changes apply instantly and are saved
        locally.
      </p>

      {/* ===== TWO COLUMN CONTENT ===== */}
      <div style={row}>
        {/* ===== LEFT COLUMN ===== */}
        <div style={col}>
          <h3 style={s.h3}>Theme</h3>
          <ul>
            <li>Choose the visual appearance of the app</li>
            <li>Options: Light, Dark, or System default</li>
          </ul>

          <h3 style={s.h3}>Answer Direction</h3>
          <ul>
            <li>Controls how numbers are read and answered</li>
            <li>Left to Right</li>
            <li>Right to Left</li>
          </ul>

          <h3 style={s.h3}>Show Problem Number</h3>
          <ul>
            <li>Displays the current question number during practice</li>
            <li>Useful for tracking progress</li>
          </ul>

          <h3 style={s.h3}>Show Timer</h3>
          <ul>
            <li>Shows or hides the timer during practice</li>
            <li>Helps users focus on speed-based training</li>
          </ul>

          {/* ===== IMPORTANT NOTES ===== */}
          <h3 style={s.h3}>Important Notes</h3>
          <ul>
            <li>
              <strong>Stream Speed Rule:</strong> Medium and Hard speeds are
              derived from Easy mode using the selected difficulty rule.
            </li>
            <li>
              <strong>Abort Button Limitation:</strong> Disabling the abort
              button has no effect when the number of questions is set to
              unlimited.
            </li>
          </ul>
        </div>

        {/* ===== RIGHT COLUMN ===== */}
        <div style={col}>
          <h3 style={s.h3}>Timer Mode</h3>
          <ul>
            <li>Controls how time is measured</li>
            <li>Problem → time per question</li>
            <li>Total → time for the entire test</li>
          </ul>

          <h3 style={s.h3}>Show Abort Button</h3>
          <ul>
            <li>Enables or disables the abort (end test) button</li>
            <li>Useful for controlled practice sessions</li>
          </ul>

          <h3 style={s.h3}>Stream Speed</h3>
          <ul>
            <li>Controls number display speed in Stream Mode</li>
            <li>Easy mode is user-defined</li>
            <li>Medium and Hard are calculated automatically</li>
          </ul>

          <h3 style={s.h3}>Reset to Default</h3>
          <ul>
            <li>Restores all settings to their default values</li>
            <li>Does not delete profile or test history</li>
          </ul>
        </div>
      </div>

      {/* ===== FULL WIDTH IMAGE ===== */}
      <img src={settingsPage} alt="Settings Page" style={imgSettings} />
    </Section>
  );
}
function ResetCenterGuide() {
  const row = {
    display: "flex",
    gap: 36,
    alignItems: "flex-start",
    marginTop: 32,
  };

  const col = { flex: 1 };

  const imgCustomDate = {
    width: "100%",
    maxWidth: 620,
    minHeight: 95,
    borderRadius: 12,
  };

  const imgCustomTest = {
    width: "100%",
    maxWidth: 460,
    minHeight: 120,
    borderRadius: 12,
  };

  const imgExport = {
    width: "100%",
    maxWidth: 900,
    minHeight: 420,
    borderRadius: 18,
  };

  const imgHistoryMain = {
    width: "100%",
    maxWidth: "100%",
    minHeight: 160,
    marginTop: 28,
    borderRadius: 16,
  };

  const imgResetFull = {
    width: "100%",
    maxWidth: "100%",
    height: "auto",
    minHeight: 320,
    marginTop: 48,
    borderRadius: 18,
    display: "block",
  };

  return (
    <Section title="Reset Center">
      <p>
        The Reset Center allows users to manage, export, or delete stored
        practice data. All actions affect locally stored data only.
      </p>

      {/* ===== RESET TEST HISTORY ===== */}
      <div style={row}>
        <div style={col}>
          <h3 style={s.h3}>Reset Test History</h3>
          <ul>
            <li>Deletes selected test history based on chosen criteria</li>
            <li>
              Users can filter tests by:
              <ul>
                <li>Type (All, Normal, Stream)</li>
                <li>Test number</li>
                <li>Date range</li>
              </ul>
            </li>
            <li>Only selected records are removed</li>
            <li>Remaining history stays untouched</li>
          </ul>
        </div>

        <div style={col}>
          <img
            src={resetCustomDate}
            alt="Custom Date Filter"
            style={imgCustomDate}
          />
          <img
            src={resetCustomTest}
            alt="Custom Test Filter"
            style={imgCustomTest}
          />
        </div>
      </div>

      {/* ===== RESET HISTORY MAIN ===== */}
      <img src={resetHistoryMain} alt="Reset History" style={imgHistoryMain} />

      {/* ===== EXPORT TEST HISTORY ===== */}
      <div style={row}>
        <div style={col}>
          <h3 style={s.h3}>Export Test History</h3>
          <ul>
            <li>Exports test history as a spreadsheet file</li>
            <li>Useful for offline review or progress tracking</li>
            <li>Use an Excel / XLSX / CSV viewer to open the exported file</li>
          </ul>
        </div>

        <div style={col}>
          <img
            src={resetExportHistory}
            alt="Export History"
            style={imgExport}
          />
        </div>
      </div>

      {/* ===== RESET ANALYSIS + CLEAR EVERYTHING ===== */}
      <div style={row}>
        <div style={col}>
          <h3 style={s.h3}>Reset Analysis Only</h3>
          <ul>
            <li>Analysis is generated dynamically from test history</li>
            <li>Analysis cannot be reset independently</li>
            <li>
              Resetting analysis requires modifying or deleting test history
            </li>
            <li>This option is currently unavailable</li>
          </ul>

          <h3 style={s.h3}>Clear Everything</h3>
          <ul>
            <li>Deletes profile, history, analysis, and app settings</li>
            <li>Resets the app to its initial state</li>
            <li>On next use, onboarding popup appears again</li>
          </ul>
        </div>
      </div>

      {/* ===== VISUAL SUMMARY ===== */}
      <div style={{ marginTop: 56 }}>
        <img
          src={resetCombined}
          alt="Reset Center Overview"
          style={imgResetFull}
        />
      </div>

      {/* ===== IMPORTANT NOTES ===== */}
      <h3 style={s.h3}>Important Notes</h3>
      <ul>
        <li>Deleted data cannot be recovered</li>
        <li>Reset actions take effect immediately</li>
        <li>Export important data before clearing history</li>
        <li>All data handling happens locally on the user’s device</li>
      </ul>

      {/* ===== FULL RESET CENTER IMAGE ===== */}
      <img
        src={resetCenterFull}
        alt="Reset Center Full View"
        style={{
          width: "100%",
          minHeight: 520,
          marginTop: 48,
          borderRadius: 20,
        }}
      />
    </Section>
  );
}
function PDFSlideShow() {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);

  const arrowStyle = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(0,0,0,0.85)",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    width: 54,
    height: 54,
    cursor: "pointer",
    fontSize: 26,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const startAutoPlay = () => {
    if (intervalRef.current) return; // ⛔ prevent double interval
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % PDF_SLIDES.length);
    }, 3000);
  };

  const stopAutoPlay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
  }, []);

  const next = () => setCurrent((prev) => (prev + 1) % PDF_SLIDES.length);

  const prev = () =>
    setCurrent((prev) => (prev === 0 ? PDF_SLIDES.length - 1 : prev - 1));

  return (
    <div
      onMouseEnter={stopAutoPlay}
      onMouseLeave={startAutoPlay}
      style={{
        width: "100%",
        maxWidth: 1000,
        margin: "24px auto",
        borderRadius: 16,
        overflow: "hidden",
        position: "relative",
        background: "#000",
        boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
      }}
    >
      <img
        src={PDF_SLIDES[current]}
        alt={`Guide slide ${current + 1}`}
        style={{ width: "100%", display: "block" }}
      />

      {/* LEFT */}
      <button
        onClick={prev}
        style={{
          position: "absolute",
          left: 12,
          top: "50%",
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.65)",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: 36,
          height: 36,
          cursor: "pointer",
          fontSize: 18,
        }}
      >
        ‹
      </button>

      {/* RIGHT */}
      <button
        onClick={next}
        style={{
          position: "absolute",
          right: 12,
          top: "50%",
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.65)",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: 36,
          height: 36,
          cursor: "pointer",
          fontSize: 18,
        }}
      >
        ›
      </button>
    </div>
  );
}

function PDFGuide() {
  return (
    <Section title="Full User Guide (PDF)">
      <p>
        Preview important sections of the guide using the slides below. You can
        open the complete PDF in a new tab or download it directly.
      </p>

      <p
        style={{
          marginTop: 12,
          fontSize: 13,
          opacity: 0.75,
        }}
      >
        <strong>Tip:</strong> Hover over the slides to pause auto-play. Use
        arrows to navigate manually.
      </p>

      <PDFSlideShow />

      {/* ACTION BUTTONS */}
      <div style={{ display: "flex", gap: 14, marginTop: 18 }}>
        <a
          href="/guides/guide.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            padding: "10px 16px",
            borderRadius: 10,
            background: "linear-gradient(135deg,#7c3aed,#9333ea)",
            color: "#fff",
            textDecoration: "none",
            fontWeight: 600,
            boxShadow: "0 0 18px rgba(167,139,250,0.6)",
          }}
        >
          📄 Open in New Tab
        </a>

        <a
          href="/guides/guide.pdf"
          download="SpeedDigits-Trainer-User-Guide.pdf"
          style={{
            padding: "10px 16px",
            borderRadius: 10,
            background: "linear-gradient(135deg,#9333ea,#ec4899)",
            color: "#fff",
            textDecoration: "none",
            fontWeight: 600,
            boxShadow: "0 0 18px rgba(236,72,153,0.6)",
          }}
        >
          ⬇ Download PDF
        </a>
      </div>
    </Section>
  );
}

const s = {
  /* ===== LAYOUT ===== */
  wrapper: {
    display: "flex",
    height: "100%",
    background: "var(--app-bg)",
  },

  /* ===== SIDEBAR (ROUNDED + DARK MODE SAFE) ===== */
  sidebar: {
    width: 290,
    padding: "28px 20px",
    margin: 16,
    position: "sticky",
    top: 16,

    height: "calc(100vh - 32px)", // 🔥 synced height
    overflowY: "auto", // 🔥 enable scroll
    direction: "rtl", // 🔥 scrollbar on LEFT

    borderRadius: 24,
    background: "#ede9fe", // light purple (Tailwind violet-100)
    border: "1px solid #c4b5fd",
    boxShadow: "none",
  },

  sideTitle: {
    direction: "ltr", // 🔥 text normal
    textAlign: "center",
    fontSize: 19,
    fontWeight: 800,
    marginBottom: 24,
    paddingLeft: 8,
    color: "#6d28d9",
  },

  scrollColumn: {
    width: 6, // 🔥 very thin
    height: "100vh",
    overflowY: "auto",

    background: "transparent",

    scrollbarWidth: "thin", // Firefox
    scrollbarColor: "#a855f7 transparent",
  },

  sideItem: {
    direction: "ltr", // 🔥 text normal
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "14px 16px 14px 30px",
    marginBottom: 20,
    borderRadius: 16,
    background: "#f5f3ff",
    color: "#1f2937",
    fontSize: 16,
    fontWeight: 600,

    /* 🔥 FIX */
    color: "var(--sidebar-text)",
    fontSize: 15,
    fontWeight: 600,

    transition: "all 0.25s ease",
  },

  sideItemActive: {
    border: "1px solid rgba(167,139,250,0.85)",
    background: "#8b5cf6",
    color: "#ffffff",
    boxShadow: "none",
    fontWeight: 700,
  },

  /* ===== CONTENT ===== */
  content: {
    flex: 1,
    padding: "60px 56px 80px",
    maxWidth: 1400,
    height: "calc(100vh - 32px)",
    overflowY: "auto",

    /* 🔥 FIREFOX ONLY */
    scrollbarWidth: "thin",
    scrollbarColor: "#a855f7 transparent",
  },

  divider: {
    width: 6,
    height: "calc(100vh - 32px)",
    background:
      "linear-gradient(180deg, transparent, rgba(168,85,247,0.4), transparent)",
  },

  /* ===== PAGE HEADER (EXACT LIKE REFUND) ===== */
  pageHeader: {
    textAlign: "center",
    marginBottom: 40,
  },

  pageTitle: {
    fontSize: 52, // 🔥 EXACT refund title size
    fontWeight: 800,
    background: "linear-gradient(90deg,#9333ea,#ec4899)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  pageSubTitle: {
    marginTop: 10, // 🔥 EXACT refund spacing
    fontSize: 14, // 🔥 EXACT refund subtitle size
    opacity: 0.7,
    maxWidth: 760,
    marginInline: "auto",
  },

  /* ===== SECTION CARD ===== */
  sectionCard: {
    background: "#ffffff",
    border: "1px solid #e9d5ff",
    boxShadow: "0 10px 30px rgba(124,58,237,0.15)",
    borderRadius: 24,
    padding: "44px 48px",
    marginBottom: 60,
    overflow: "hidden",
  },

  sectionBody: {
    fontSize: 16,
    lineHeight: 1.85,
    opacity: 0.92,
  },

  /* ===== SECTION TITLE ===== */
  h2: {
    textAlign: "center",
    fontSize: 52, // 🔥 EXACT refund sectionTitle
    fontWeight: 700,
    color: "#a855f7",
    marginBottom: 16,
  },

  h3: {
    fontSize: 18, // ✅ Refund-style subheader
    fontWeight: 700,
    color: "#c084fc", // ✅ visible purple
    marginTop: 32,
    marginBottom: 14,
  },

  h4: {
    fontSize: 16,
    fontWeight: 600,
    color: "#d8b4fe",
    marginTop: 18,
    marginBottom: 10,
  },

  /* ===== SPLIT ===== */
  split: {
    display: "flex",
    gap: 40,
    alignItems: "center",
    flexWrap: "wrap",
  },

  text: {
    flex: 1,
    fontSize: 16,
    lineHeight: 1.85,
    opacity: 0.95,
  },

  image: {
    flex: 1,
    maxWidth: "100%",
    width: "100%",
    height: "auto",

    borderRadius: 16,
    objectFit: "contain",

    boxShadow: "0 16px 44px rgba(124,58,237,0.35)",
  },
};
